import { render, staticRenderFns } from "./classCation.vue?vue&type=template&id=51e122b8&scoped=true"
import script from "./classCation.vue?vue&type=script&lang=js"
export * from "./classCation.vue?vue&type=script&lang=js"
import style0 from "./classCation.vue?vue&type=style&index=0&id=51e122b8&prod&lang=css"
import style1 from "./classCation.vue?vue&type=style&index=1&id=51e122b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e122b8",
  null
  
)

export default component.exports